<template>
  <section class="utilization-insight-bridge">
    <PrincipalDetailInsight
      v-if="usePrincipalInsight"
      :clientId="encounter.client_id"
      :principalId="encounter.principal_id"
      :policyId="resolvedPolicyId"
      :encounterDate="resolvedEncounterDate"
      @reset="handleReset"
    />

    <EnrolleeDetailInsight
      v-else-if="encounter?.enrollee_number"
      :enrolleeNumber="encounter.enrollee_number"
      @reset="handleReset"
    />

    <div class="utilization-empty-note" v-else>
      <i class="material-icons">info_outline</i>
      <span>Utilization is not available for this enrollee.</span>
    </div>
  </section>
</template>

<script>
import { computed } from "vue";
import PrincipalDetailInsight from "@/components/insight/PrincipalDetailInsightComponent.vue";
import EnrolleeDetailInsight from "@/components/insight/EnrolleeDetailInsightComponent.vue";

export default {
  name: "UtilizationInsightComponent",
  components: { PrincipalDetailInsight, EnrolleeDetailInsight },
  props: {
    encounter: {
      type: Object,
      default: null,
    },
    policyId: {
      type: [String, Number],
      default: null,
    },
  },
  emits: ["reset"],
  setup(props, context) {
    const usePrincipalInsight = computed(() => {
      return Number(props.encounter?.principal_id || 0) > 0 && props.encounter?.client_id;
    });

    const resolvedPolicyId = computed(() => {
      return props.policyId ||
        props.encounter?.policy_id ||
        props.encounter?.policy?.id ||
        props.encounter?.invoice?.invoice_group?.policy_id ||
        props.encounter?.invoice_group?.policy_id ||
        props.encounter?.cluster?.policy_id ||
        null;
    });

    const resolvedEncounterDate = computed(() => {
      return props.encounter?.encounter_date || null;
    });

    const handleReset = () => {
      context.emit("reset", true);
    };

    return {
      usePrincipalInsight,
      resolvedPolicyId,
      resolvedEncounterDate,
      handleReset,
    };
  },
};
</script>

<style scoped>
.utilization-insight-bridge {
  width: 100%;
}

.utilization-empty-note {
  align-items: center;
  background: #f8fafb;
  border: 1px solid #e1e8eb;
  border-radius: 6px;
  color: #607d8b;
  display: flex;
  gap: 8px;
  justify-content: center;
  min-height: 90px;
  padding: 18px;
}

.utilization-empty-note i {
  color: #00897b;
  font-size: 20px;
}
</style>
